import MaterialTable from '@material-ui/core/Table';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSortBy, useTable } from 'react-table';
import Body from './body/Body';
import Head from './head/Head';
import { TableHeaderExact } from '../models/tableHeader';
import { TableRowActionExact } from '../models/tableRowAction';
import { Loader } from '../../common/components/loaders';
import useStyles from './Table.styles';

export const defaultTake = 10;
export const defaultTakeForClients = 30;
export const halfPageTableHeight = 300;
export const fullPageTableHeight = 548;

export const sizeEnum = {
  small: 'small',
  medium: 'medium',
};

const Table = ({ columns, data, onRowClick, rowActions, height, onPageChange, take, size, headerStyle, selectedRowEntityId, hasMore }) => {
  const classes = useStyles();

  const { headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

  const handlePageChange = useCallback(() => {
    if (onPageChange) {
      onPageChange({ take, skip: data.length });
    }
  }, [data, onPageChange, take]);

  // Use provided hasMore if available, otherwise calculate based on modulo
  const hasMoreData = useMemo(() => {
    if (hasMore !== undefined) return hasMore;
    if (!onPageChange || data.length === 0) return false;
    return data.length % take === 0;
  }, [hasMore, onPageChange, data, take]);

  return (
    <>
      <InfiniteScroll dataLength={data.length} height={height} next={handlePageChange} loader={<Loader className={classes.loader} />} hasMore={hasMoreData}>
        <MaterialTable size={size} stickyHeader>
          <Head headerGroups={headerGroups} hasActions={rowActions && !!rowActions.length} headerStyle={headerStyle} />
          <Body rows={rows} prepareRow={prepareRow} onRowClick={onRowClick} rowActions={rowActions} selectedRowEntityId={selectedRowEntityId} />
        </MaterialTable>
      </InfiniteScroll>
    </>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(TableHeaderExact).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  hasMore: PropTypes.bool,
  headerStyle: PropTypes.shape(),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onPageChange: PropTypes.func,
  onRowClick: PropTypes.func,
  rowActions: PropTypes.arrayOf(TableRowActionExact),
  selectedRowEntityId: PropTypes.number,
  size: PropTypes.oneOf(Object.values(sizeEnum)),
  take: PropTypes.number,
};

Table.defaultProps = {
  hasMore: undefined,
  headerStyle: undefined,
  height: undefined,
  onPageChange: undefined,
  onRowClick: undefined,
  rowActions: [],
  selectedRowEntityId: undefined,
  size: sizeEnum.medium,
  take: defaultTake,
};

export default Table;
